import NotFoundPage from '@/ui-components/pages/NotFoundPage'

const Page404 = () => {
  return <NotFoundPage />
}

export default Page404
